module.exports = __webpack_public_path__ + "static/Principal-afcccd92d0b1555b733d7d34160fdfc9.jpg";